import React from 'react'
import { css, cx } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { CsCloseIcon } from '../icons'
import { TagContainer } from './tag-container'

const maxWidthSize = 143

const tagTextCss = css`
  z-index: 0;
  color: ${theme.color.neutral90};
  display: inline-block;
  max-width: ${maxWidthSize}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  height: 18px;
  line-height: 18px;
`

const tagEllipsisTextCss = css`
  display: inline-block;
  max-width: ${maxWidthSize}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
`

const closeIconCss = css`
  margin: 1px 0 0 4px;
`

const smallTagContainerCss = css`
  margin: 0px;
  padding: 0px;

  z-index: 0;
  align-items: center;
  display: flex;
`

interface Props {
  readonly children: string | React.ReactNode
  readonly onRemove?: () => any
  readonly className?: string
  readonly innerRef?: (ref: any) => void
}

interface TagWithTooltipProps {
  readonly children: string | React.ReactNode
}

interface TagWithTooltipState {
  readonly isTextTruncated?: boolean
}

interface TagTextProps {
  readonly children: string
}

export function TagText({ children }: TagTextProps) {
  return <span className={cx(tagTextCss, tagEllipsisTextCss)}>{children}</span>
}

class TagWithTooltip extends React.Component<
  TagWithTooltipProps,
  TagWithTooltipState
> {
  private rootElement: any

  constructor(props) {
    super(props)

    this.state = {
      isTextTruncated: false
    }
  }

  public render() {
    const { children } = this.props

    return (
      <div
        ref={(ref) => (this.rootElement = ref)}
        className={smallTagContainerCss}
        onMouseEnter={() => this.onMouseEnter()}
        onMouseLeave={() => this.onMouseOut()}
      >
        <span className={tagTextCss}>{children}</span>
      </div>
    )
  }

  private onMouseEnter() {
    this.rootElement.offsetWidth >= maxWidthSize
      ? this.updateTextTruncatedState(true)
      : this.updateTextTruncatedState(false)
  }

  private onMouseOut() {
    this.updateTextTruncatedState(false)
  }

  private updateTextTruncatedState(isTextTrucated: boolean) {
    this.setState({
      isTextTruncated: isTextTrucated
    })
  }
}

export function Tag({ children, onRemove, className, innerRef }: Props) {
  return (
    <TagContainer className={className} innerRef={innerRef}>
      <TagWithTooltip>{children}</TagWithTooltip>
      {onRemove && <CsCloseIcon className={closeIconCss} onClick={onRemove} />}
    </TagContainer>
  )
}
